// Client helpers for the handoff token flow (compare redesign, phase 2).
// Thin fetch wrappers around /api/handoff/* so client components don't
// duplicate the request shape. Both fail soft (null) so callers fall back
// to their cold-start path.

export async function mintHandoff(
  purpose: string,
  payload: object,
  ttlSeconds?: number,
): Promise<string | null> {
  try {
    const r = await fetch('/api/handoff/create', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ purpose, payload, ttlSeconds }),
    });
    if (!r.ok) return null;
    const j = (await r.json()) as { token?: string };
    return typeof j.token === 'string' ? j.token : null;
  } catch {
    return null;
  }
}

export async function readHandoff<T>(token: string, purpose: string): Promise<T | null> {
  try {
    const r = await fetch('/api/handoff/consume', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, purpose }),
    });
    if (!r.ok) return null;
    const j = (await r.json()) as { payload?: T };
    return (j.payload ?? null) as T | null;
  } catch {
    return null;
  }
}
